import { graphql } from '@search/gql-client/src';

export const OrderOfferVasMutation = graphql`
    mutation OrderOfferVasMutation(
        $offersParams: [OrderOfferVasOfferParam!]!,
        $vases: [BuyableVasGQLEnum!]!,
        $durationDays: Int!,
        $phone: String,
        $promocode: String,
    ) {
        orderOfferVas(
            offersParams: $offersParams,
            vases: $vases,
            durationDays: $durationDays,
            phone: $phone,
            promocode: $promocode,
        ) {
            redirectUrl
            bffError
        }
    }
`;
